import type { FC } from "react";
import classnames from "classnames";
import { EntityLogo } from "@/components/entity-logo/EntityLogo";
import type { MatchScoreCompetition as MatchScoreCompetitionComponent } from "@motain/xpa-proto-files-web/lib/types/match_score";
import { isNullable } from "@/types/isNullable";
import styles from "./MatchScoreCompetition.module.scss";
import Link from "next/link";
import { trackingService } from "@/modules/analytics";
import { EventType } from "@motain/xpa-proto-files-web/lib/types/tracking";

export const MatchScoreCompetition: FC<MatchScoreCompetitionComponent> = (
  props,
) => {
  const { name, icon, link } = props;

  if (isNullable(icon) || isNullable(name) || isNullable(link)) {
    return <></>;
  }

  return (
    <Link
      href={link.urlPath}
      onClick={() => {
        trackingService.sendXpaTracking(
          link.trackingEvents,
          EventType.EVENT_CLICK,
        );
      }}
      className={styles.competition}
    >
      <EntityLogo
        alt={icon.alt}
        src={icon.path}
        className={styles.compectitionLogo}
      />
      <span className={classnames("title-7-medium", styles.competitionName)}>
        {name}
      </span>
    </Link>
  );
};
